import { useHotkeys } from 'react-hotkeys-hook';

// This component uses a pattern to handle conditional hooks. It allows the use of the useHotkeys hook
// only when certain conditions are met, facilitating the separation of logic from the UI.
const HotKeyController = _ref => {
  let {
    hotKey,
    keyScope,
    handleAction,
    enabled
  } = _ref;
  useHotkeys(hotKey, handleAction, {
    scopes: keyScope,
    enabled
  });
  return null;
};
var HotKeyController$1 = HotKeyController;

export { HotKeyController$1 as default };
//# sourceMappingURL=HotKeyController.js.map
